import { Grid } from "@material-ui/core";
import React from "react";
import { InputWithErrorLabel as Input } from "components/haven-design/form/inputs";
import { extendedStatesList } from "components/haven-design/state-picker";
import { MaterialFormikSelectAutocomplete as SelectAutocomplete } from "components/haven-design/form/select";

type AddressProps = {
  // prefix will be implemented for nested addresses (e.g. property residence + mailing)
  prefix?: string,
}

const AddressGroup: React.FC<AddressProps> = () => (<>
  <Grid container item xs={12} md={8}>
    <Input margin="none" label="Address" required name="address1" />
  </Grid>
  <Grid container item xs={12} md={8}>
    <Input margin="none" label="Address 2" name="address2" />
  </Grid>
  <Grid container item xs={12} md={5}>
    <Input margin="none" label="City" required name="city" />
  </Grid>
  <Grid container item xs={6} md={3}>
    <SelectAutocomplete
      id="state"
      margin="none"
      name="state"
      placeholder="State *"
      title="State"
      required
      fullWidth
      options={extendedStatesList}
    />
  </Grid>
  <Grid container item xs={6} md={3}>
    <Input margin="none" label="Zip" required name="zip" inputProps={{ maxLength: "5" }}/>
  </Grid>

</>);
export default AddressGroup;
